const defaultState = {
  pagCount: 1,
  maxCount: 1,
  theFilteredListing: [],
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_PAG_COUNT':
      return {
        ...state,
        pagCount: action.pagCount,
      }
    case 'SET_MAX_COUNT':
      return {
        ...state,
        maxCount: action.maxCount,
      }
    case 'SET_THE_FILTERED_LISTING':
      return {
        ...state,
        theFilteredListing: action.theFilteredListing,
      }
    default:
      return state;
  };
};